import { Injectable } from '@angular/core';
import { DEFAULT_MARKET_ID, MarketId, marketForTimeZone } from '../../../../src/markets';

/**
 * Which country's shops this tab searches: the one the device's clock is set
 * to, or the default when the time zone isn't a country (UTC) or can't be read.
 *
 * The time zone, not the browser language: phones and laptops switch zones
 * automatically on arrival, so it follows the shopper across borders, while a
 * Bulgarian in Madrid still has a Bulgarian browser. Read once per page load.
 */
@Injectable({ providedIn: 'root' })
export class MarketService {
   /** The country the device's clock is set in, or undefined when it isn't one. */
   readonly detected: MarketId | undefined = detectMarket();
   readonly current: MarketId = this.detected ?? DEFAULT_MARKET_ID;
}

function detectMarket(): MarketId | undefined {
   try {
      return marketForTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
   } catch {
      return undefined;
   }
}
